import { requestREST } from "~/client/http/CommonHTTP";
import { NetworkResponse } from "~/app/type/common";
import {
  DataFilterIProps,
  FilterLogIvideonIProps,
  IvideonDataResponse,
  IvideonEventLogs,
  IvideonLogsFileHash,
  LogsCronIProps,
  LogsCronResponseIProps,
  LogsNamesIProps,
} from "../model/schema";

const LogsServiceMap = {
  getIvideonLogs: "/logs/activity",
  getIvideonEventTypes: "/logs/event-types",
  getIvideonLogsFileHash: "/logs/activity-report",
  getLogsNames: "/logs/cron/names",
  getLogsCron: "/logs/cron",
};

export class LogsService {
  static GET = {
    getIvideonLogs: (
      params: FilterLogIvideonIProps
    ): NetworkResponse<IvideonDataResponse> =>
      requestREST.get(LogsServiceMap.getIvideonLogs, { params }),
    getIvideonEventTypes: (): NetworkResponse<IvideonEventLogs[]> =>
      requestREST.get(LogsServiceMap.getIvideonEventTypes),
    getIvideonLogsFileHash: (
      params: DataFilterIProps
    ): NetworkResponse<IvideonLogsFileHash> =>
      requestREST.get(LogsServiceMap.getIvideonLogsFileHash, { params }),
    getLogsNames: (): NetworkResponse<LogsNamesIProps> =>
      requestREST.get(LogsServiceMap.getLogsNames),
    getLogsCron: (
      params: LogsCronIProps
    ): NetworkResponse<LogsCronResponseIProps> =>
      requestREST.get(LogsServiceMap.getLogsCron, { params }),
  };
}
